import { html } from 'lit';
const File =
  ({ width = '1em', height = '1em', style = '' }: { width?: string, height?: string, style?: string } = {}) =>
    html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${'user-select:none;flex-shrink:0;' + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M8.17 2.25H13a.75.75 0 0 1 .53.22l6 6c.141.14.22.331.22.53v8.83c0 .535 0 .98-.03 1.345-.03.38-.098.736-.27 1.073a2.75 2.75 0 0 1-1.201 1.202c-.338.172-.694.24-1.074.27-.365.03-.81.03-1.344.03H8.17c-.535 0-.98 0-1.345-.03-.38-.03-.736-.098-1.073-.27A2.75 2.75 0 0 1 4.55 20.25c-.172-.338-.24-.694-.27-1.074-.03-.365-.03-.81-.03-1.345V6.17c0-.535 0-.98.03-1.345.03-.38.098-.736.27-1.073A2.75 2.75 0 0 1 5.752 2.55c.337-.172.693-.24 1.073-.27.365-.03.81-.03 1.345-.03M6.947 3.775c-.287.023-.424.065-.514.111a1.25 1.25 0 0 0-.547.547c-.046.09-.088.227-.111.514-.024.296-.025.68-.025 1.253v11.6c0 .572 0 .957.025 1.252.023.288.065.425.111.515.12.236.311.427.547.547.09.046.227.088.514.111.296.024.68.025 1.253.025h7.6c.572 0 .957 0 1.252-.025.288-.023.425-.065.515-.111a1.25 1.25 0 0 0 .547-.547c.046-.09.088-.227.111-.515.024-.295.025-.68.025-1.252V9.75H14A1.75 1.75 0 0 1 12.25 8V3.75H8.2c-.572 0-.957 0-1.253.025M13.75 4.81l3.44 3.439H14a.25.25 0 0 1-.25-.25z" clip-rule="evenodd"/>
  </svg>
`;
export default File;
